var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4300_16664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.70027 17.0945C9.62327 17.4177 9.37009 18.4088 8.32303 18.7107C7.92239 18.8305 7.47345 18.8234 7.06508 18.8234H5V13.8621H6.68609C6.90369 13.8621 7.1285 13.8691 7.34678 13.876C8.00661 13.9042 8.61127 13.9673 9.10988 14.4454C9.43334 14.7618 9.77761 15.3166 9.77761 16.3213C9.77761 16.6871 9.72828 16.9609 9.70009 17.0945H9.70027ZM7.74708 15.1621C7.59927 15.0709 7.47998 15.0216 7.16408 15.0216H6.57386V17.6849H7.17095C7.33922 17.6849 7.47363 17.6713 7.62763 17.5936C8.21063 17.3123 8.1967 16.4201 8.1967 16.3426C8.1967 16.3006 8.21063 15.4641 7.74708 15.1621Z",
    fill: "#54ADC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875 18.8234V13.8621H13.4422V17.5726H15.5344V18.8234H11.875Z",
    fill: "#54ADC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9727 18.8235V13.8485H17.4198V18.8233H15.9727V18.8235Z",
    fill: "#54ADC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0361 18.8234H19.3989L17.7412 13.8621H19.3427L20.2282 16.9051L21.1064 13.8621H22.7149L21.0359 18.8234H21.0361Z",
    fill: "#54ADC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0366 18.8234V13.8621H27.0001V14.9515H24.6107V15.8057H26.8094V16.8808H24.6039V17.7481H27.0002V18.8236H23.0368L23.0366 18.8234Z",
    fill: "#54ADC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.484 13.8622C11.484 14.6617 10.8365 15.3095 10.0366 15.3095V13.8622H11.484Z",
    fill: "#54ADC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9727 12C16.7714 12 17.4198 12.6476 17.4198 13.4475H15.9727V12Z",
    fill: "#54ADC5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4300_16664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 6.82353,
    fill: "white",
    transform: "translate(5 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDl);
export default __webpack_public_path__ + "static/media/dl.c305bce70dae470ca562443a5c838e55.svg";
export { ForwardRef as ReactComponent };